<template>
  <div>
      <topTab :changeTabIndex='0'></topTab>
      <homepage></homepage>    
      <bottomMsg></bottomMsg>
  </div>
</template>

<script>
// @ is an alias to /src
import homepage from "@/components/home/home.vue"
import bottomMsg from "@/components/bottomMsg/bottomMsg.vue"
import topTab from "@/components/topTab/topTab.vue"
export default {
  name: 'home',
  components: {
    homepage,
    bottomMsg,
    topTab
  }
}
</script>
